import { useTranslations } from 'next-intl';

import type { IconRef, ItemType } from '@/config/itemTypes';
import dugoutMenuIcon from '@/utils/dugoutMenuIcon';

interface DefaultItemsProps {
  defaultTypes: ItemType[];
  iconType: string;
  // Passed rather than read from ToolContext: DefaultItems is purely presentational and its
  // tests/stories render it without a provider.
  isDugoutTheme?: boolean;
}

const DefaultItems = ({
  defaultTypes,
  iconType,
  isDugoutTheme = false,
}: DefaultItemsProps) => {
  const t = useTranslations();

  // Dugout QuickMenu thumbnails recolour per team like the main menu (visual <img> only; data-* stay
  // raw for drag/drop). Non-dugout themes render the raw defaultIcon — byte-identical to before.
  const iconSrc = (item: ItemType) =>
    isDugoutTheme ? dugoutMenuIcon(item, iconType) : item.defaultIcon.src;

  return (
    <section className="DefaultItems">
      <div className="Section-inner">
        {defaultTypes.map((item) => (
          <div className="DefaultItems-imageContainer" key={item.variation}>
            <div
              className={`Draggable-itemWrap ${item.variation.includes('cone') ? 'Item--cone' : ''}`}
              data-label={t(`DRWNG__ITEM_${item.variation}`)}
              data-variation={item.variation}
              data-name={t(`DRWNG__ITEM_${item.variation}`)}
              data-color={item.color}
              data-width={item.width}
              data-height={item.height}
              data-default-icon={item.defaultIcon.src}
              data-src={
                (item[iconType as keyof ItemType] as IconRef | undefined)?.src
              }
              data-field={item.text}
              data-font-color={item.fontColor}
            >
              <img src={iconSrc(item)} alt="" />
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default DefaultItems;
